<template>
  <div class="segment-wrap">
    <div
      class="segment-control"
      :style="{
        '--active-index': activeIndex,
        '--tab-count': tabs.length,
      }"
    >
      <button
        v-for="(tab, index) in tabs"
        :key="index"
        :class="{ on: currentTab === tab.value }"
        type="button"
        class="segment-btn"
        @click="selectTab(tab.value)"
      >
        {{ t(tab.label) }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { AppTabButton } from '@/types/components';

const currentTab = defineModel<string>({
  required: true,
  default: '',
});

const props = withDefaults(
  defineProps<{
    tabs: AppTabButton[];
  }>(),
  {
    tabs: () => [],
  }
);

const { t } = useI18n();

const activeIndex = computed(() => {
  const index = props.tabs.findIndex((tab) => tab.value === currentTab.value);
  return index !== -1 ? index : 0;
});

const selectTab = (value: string) => {
  currentTab.value = value;
};
</script>

<style scoped lang="scss">
.segment-wrap {
  margin-top: 1rem;

  .segment-control {
    position: relative;
    display: flex;
    border-radius: $size-s;
    background: $gray10;
    padding: 0.25rem;

    // 활성화된 탭의 배경
    &::before {
      content: '';
      position: absolute;
      top: 0.25rem;
      bottom: 0.25rem;
      left: calc(var(--active-index) * (100% / var(--tab-count)) + 0.25rem);
      width: calc(100% / var(--tab-count) - 0.5rem);
      flex: 1;
      background: white;
      border-radius: $size-s;
      transition:
        left 0.3s ease,
        width 0.3s ease;
      z-index: 0;
    }

    .segment-btn {
      position: relative;
      z-index: 1;
      flex: 1;
      padding: 0.5rem 1rem;
      background: transparent;
      border: none;
      cursor: pointer;
      transition: color 0.3s ease;
    }
  }
}
</style>
